import { combineReducers } from 'redux';

import AppState from '~/modules/App/AppState';
import { localeReducer as locale } from 'react-localize-redux';

export default combineReducers({
  AppState,
  locale
});



// WEBPACK FOOTER //
// ./src/redux/reducer.js